import { Chip } from "primereact/chip";
import React, { useEffect, useRef, useState } from "react";

interface Props {
    name :string;
    categ: string;
    color:string;
}

export const Label = ({categ,name,color}:Props) => {

    const label:string = `${categ} | ${name}` 
    return (
        <>
        <Chip style={{backgroundColor:color,color:"white"}} label={label}/>      
        </>
    )

}